module.exports = __webpack_public_path__ + "img/right-small-arrow.d4c27fd3.png";